import { API_BASE_URL } from './index';
import { getToken, getUser } from './auth';

/**
 * @param {{ role: 'user' | 'assistant'; content: string }[]} messages
 * @returns {Promise<{ reply: string }>}
 */
export async function sendAssistantChat(messages) {
  const token = getToken();
  const user = getUser();

  if (!token) {
    throw new Error('No authentication token');
  }
  if (!user?.companyId) {
    throw new Error('Company ID not available');
  }

  const response = await fetch(`${API_BASE_URL}/api/assist/chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Session-Token': token,
      'X-Company-ID': user.companyId,
    },
    body: JSON.stringify({ messages }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'No se pudo enviar el mensaje');
  }

  return {
    reply: typeof data.reply === 'string' ? data.reply : data.reply != null ? String(data.reply) : '',
    model: data.model,
  };
}
